import * as tslib_1 from "tslib";
import { environment } from '../environment';
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var SystemMessagesApi = /** @class */ (function () {
    function SystemMessagesApi(api) {
        this.api = api;
    }
    SystemMessagesApi.prototype.getSystemMessages = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSystemMessages($applicationId: Int) {\n                systemMessage(applicationId: $applicationId) { id, title, message, startDate, expirationDate, createDate, systemMessageCategoryId }\n            }", { applicationId: environment.appId }, 'GET', 'systemMessage')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.prototype.deleteSystemMessage = function (systemMessageId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation DeleteSystemMessage($systemMessageId: Int!) {\n            deleteSystemMessage(id: $systemMessageId)\n        }", { systemMessageId: systemMessageId }, 'POST', 'deleteSystemMessage')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.prototype.saveSystemMessage = function (systemMessage, userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation SaveSystemMessage($systemMessage: SystemMessageInput!, $applicationId: Int!, $userId: Int!) {\n            saveSystemMessage(systemMessage: $systemMessage, applicationId: $applicationId, userId: $userId) { id, title, message, startDate, expirationDate, systemMessageCategoryId }\n        }", { systemMessage: systemMessage, userId: userId, applicationId: environment.appId }, 'POST', 'saveSystemMessage')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.prototype.getUserSystemMessageStatus = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetUserSystemMessageStatus($applicationId: Int, $userId: Int) {\n                userSystemMessageStatus(applicationId: $applicationId, userId: $userId) { systemMessageId, userId, isRead, isDismissed, systemMessage { message, expirationDate, startDate, systemMessageCategoryId, title } }\n            }", { applicationId: environment.appId, userId: userId }, 'GET', 'userSystemMessageStatus')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.prototype.saveUserSystemMessageStatus = function (systemMessageId, userId, isDismissed) {
        if (isDismissed === void 0) { isDismissed = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("mutation SaveUserSystemMessageStatus($systemMessageId: Int!, $userId: Int!, $isDismissed: Boolean) {\n            saveUserSystemMessageStatus(systemMessageId: $systemMessageId, userId: $userId, isDismissed: $isDismissed) { systemMessageId, userId, isRead, isDismissed }\n        }", { systemMessageId: systemMessageId, userId: userId, isDismissed: isDismissed }, 'POST', 'saveUserSystemMessageStatus')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.prototype.getSystemMessageCategories = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("{\n            systemMessageCategory { id, categoryName }\n        }", null, 'GET', 'systemMessageCategory')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SystemMessagesApi.ngInjectableDef = i0.defineInjectable({ factory: function SystemMessagesApi_Factory() { return new SystemMessagesApi(i0.inject(i1.Api)); }, token: SystemMessagesApi, providedIn: "root" });
    return SystemMessagesApi;
}());
export { SystemMessagesApi };
